import { GemMark } from "./Logo";

const WORDS = ["Spotless precision", "Vetted professionals", "Eco-minded products", "Room-by-room checks", "Homes · Offices · Rentals"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-8 font-display text-4xl font-bold italic tracking-tight text-white sm:text-6xl">{w}</span>
        <GemMark className="h-7 w-7 sm:h-9 sm:w-9" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-white/10 bg-[#0d1220] py-8" data-testid="editorial-marquee" aria-label="Our promise">
    <div className="marquee-track flex">
      <Row />
      <Row />
    </div>
  </section>
);
